import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EncryptionService } from '../../services/encryption.service';

@Component({
  selector: 'app-dg-file-window',
  templateUrl: './dg-file-window.component.html',
  styleUrls: ['./dg-file-window.component.scss'],
})
export class DgFileWindowComponent {
  attachId;
  viewAttach = false;
  prePath;
  mappingId;
  nameInput;
  constructor(
    private router: Router,
    private _encryptionService: EncryptionService
  ) {
    let replacedUrl = this.router.getCurrentNavigation()?.extractedUrl
      ?.queryParams?.path;
    var currentUrl = replacedUrl.split(' ').join('+');
    currentUrl = this._encryptionService.decrypt(
      currentUrl,
      this._encryptionService.param3
    );
    currentUrl = JSON.parse(currentUrl);
    this.attachId = currentUrl?.attachId;
    this.mappingId = currentUrl?.mappingId;
    this.viewAttach = currentUrl?.viewAttach;
    this.nameInput = currentUrl?.title;
    this.prePath = currentUrl?.prePath;
  }
  onPreviewClose() {
    if (this.attachId != null) {
      window.close();
    }
  }
}
